import React, {cache, useEffect, useState} from 'react';
import axios from 'axios';
import UploadFile from '../components/UploadFile';
import ChatBotMultiCase from '../components/ChatBotMultiCase';
import CaseTable from '../components/CaseTable';


export default function CaseAnalysisPage({setPage}){
    const [data, setData] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadedBatch, setUploadedBatch] = useState(null);
    const [records, setRecords] = useState([]);
    const [tableModel, setTableModel] = useState({ columns: null, rows: null });
    const [tableRows, setTableRows] = useState([]);
    
    // @app.py for page main setting
    useEffect(()=>{
        axios.get("/api/caseanalysispage") //<->methods["GET"]
        .then(res=>setData(res.data)); //setData->get res.data than save to state
    },[]);

    // clear the previous folder for tmp upload file 
    useEffect(() => {
    (async () => {
        try {
        const r = await fetch('/api/clear_uploads', { method: 'POST' });
        const j = await r.json();
        console.log('clear_uploads:', j);
        } catch (e) {
        console.error('clear_uploads failed:', e);
        }
    })();
    }, []);

    const handleUpload = async (files, tag) => {
        if (!files || files.length === 0) {
        console.warn("沒有檔案被選取");
        return;
        }
        setUploadedFiles(files);
        console.log("Uploading...");
        const formData = new FormData();
        files.forEach(f => formData.append('file', f));
        // const ext = files[0].name.split('.').pop().toLowerCase();
        formData.append('type', tag);
        const res = await axios.post('/api/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log("上傳成功", res.data);
        const savedFiles =
            res.data?.saved_files ||
            res.data?.files ||
            res.data?.filenames ||
            files.map((f) => f.name);
        setUploadedBatch({
            tag,
            uploadedAt: Date.now(),
            savedFiles,
            uploadMeta: res.data,
        });
    };

    const handleDemoUpload = async () => {
        try {
            const formData = new FormData();

            formData.append("type", "multicase");
            formData.append("demo", "true");

            const res = await axios.post(
                "/api/upload",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log("Demo upload success", res.data);

            setUploadedBatch({
                tag: "multicase",
                uploadedAt: Date.now(),
                savedFiles: res.data.results || [],
                uploadMeta: res.data,
            });

        } catch (err) {
            console.error("Demo upload failed", err);
        }
    };

    return(
        <div style={{backgroundColor: '#f9f7f2',}}>
            <div style={{textAlign:'center', display:'flex', 
                        alignItems:'center', marginLeft:'60px'}}>
                <button onClick={() => setPage('home')} 
                style={{...styles.page_button, backgroundColor: '#84D9AD'}}>
                Home Page
                </button>
                <button onClick={() => setPage('pathologic')} 
                style={{...styles.page_button, backgroundColor: '#86B6DD'}}>
                Pathologic Analysis
                </button>
                <button onClick={() => setPage('cohort')} 
                style={{...styles.page_button, backgroundColor: '#ACABDD'}}>
                Cohort Analysis
                </button>
            </div>
            <div style={{ textAlign: 'center', padding: '40px', 
                            display:'flex', gap:'30px', alignItems:'center'}}>
                {/* LOGO */}
                {data.logo_url &&(<img src={data.logo_url} alt="logo" style={{
                            width:'180px', marginBottom:'20px', marginLeft:'50px',
                            filter: 'contrast(80%) brightness(85%) hue-rotate(75deg)'
                        }}/>)}
                
                {/* TITLE */}
                <h1 style={{ color: "#6e8f9f", fontSize: '3.5rem', 
                            fontFamily: `"Microsoft JhengHei", "Noto Sans TC", sans-serif`}}>
                    {data.title}</h1>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    marginLeft: "100px",
                    gap: "40px",
                }}
                >
                {/* ✅ 左欄：Upload + Chatbot (垂直堆疊) */}
                <div
                    style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    width: "420px", // 你可以調
                    }}
                >
                    <UploadFile
                    onUpload={(files) => handleUpload(files, "multicase")}
                    accept={[".pdf"]}
                    multiple={true}
                    style={{
                        ...styles.upload_area,
                        backgroundColor: "#8CD4D9",
                        color: "#f9f7f2",
                    }}
                    title={"Upload case report files"}
                    subtitle={"Support multiple pdf files"}
                    />
                    <button
                        onClick={handleDemoUpload}
                        style={styles.demo_button}
                    >
                        Use Demo Cases
                    </button>

                    <ChatBotMultiCase 
                    uploadedBatch={uploadedBatch} 
                    onAnalysisDone={(results) => setRecords(results)}/>
                </div>

                {/* ✅ 右欄：未來顯示結果 */}
                <div style={{ flex: 1, minWidth: "600px" }}>
                <CaseTable records={records} />
                </div>

                </div>

        </div>
    )

};

const styles={
    page_button: {
        padding: '12px 26px',
        borderRadius: '8px',
        backgroundColor: '#86B6DD',
        fontWeight: '600',
        cursor: 'pointer',
        marginTop: '20px',
        fontSize: '16px',
        marginLeft:'1px',
        border:'0px',
        color:'#f9f7f2'
    },
    upload_area:{
        },
    start_button:{
        borderRadius: '32px',
        padding: '15px',
        width: '100%',
        maxWidth: '1250px',
        cursor: 'pointer',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        fontFamily: 'Noto Sans TC, sans-serif',
        marginLeft: '200px',
        marginTop: '30px',
        backgroundColor: '#CECED9',
        color:'#202143',
        fontSize:'1.2rem',
        fontWeight: '700',
        border:'none'
    },
    error_msg:{
        color: 'red',
        marginTop: '10px',
        fontWeight: 'bold',
        backgroundColor: '#ffe0e0',
        padding: '8px 12px',
        borderRadius: '8px'
    },
    demo_button: {
        borderRadius: "16px",
        padding: "12px",
        cursor: "pointer",
        backgroundColor: "#84D9AD",
        color: "#202143",
        fontWeight: "700",
        border: "none",
        width: "100%",
        fontSize: "16px",
    },
}
